module.exports = __webpack_public_path__ + "img/7.2ff78a6f.png";